import querystring from 'query-string';

export const dispatchUserChangeEvent = (uberToken, lastItemAdded) => {
    window?.SF?.notifyUserChange?.({ uberToken, lastItemAdded });
};

export const redirectToUrl = (redirect, location, locale) => {
    if (redirect !== false) {
        const { search = '' } = location;
        const { redirect: queryRedirect } = querystring.parse(search.substring(1));
        // Prevent javascript: and data: query injections
        const sanitisedQueryRedirect = queryRedirect?.replace(':', '%3A');
        const absolutePath = new RegExp('.*(www\.|\/\/)+.*');
        const accountPath = `/${locale.id}/account`;

        let redirectPath;

        if (sanitisedQueryRedirect) {
            redirectPath = absolutePath.test(sanitisedQueryRedirect) ? accountPath : sanitisedQueryRedirect;
        } else if (redirect && typeof redirect === 'string') {
            redirectPath = redirect;
        } else {
            redirectPath = accountPath;
        }

        setTimeout(() => window.location.assign(redirectPath), 0);
    }
};

export function getDeviceTypeAttr(deviceType) {
    // browser_computer for desktop, browser_mobile for mobile web, app_android or app_ios for webviews
    if (deviceType) {
        const normalizedDeviceType = deviceType.toLowerCase();
        if (['ios', 'android'].includes(normalizedDeviceType)) return `app_${normalizedDeviceType}`;
    }
    return window.innerWidth && window?.innerWidth <= 1023 ? 'browser_mobile' : 'browser_desktop';
}

export function tmHeadersParams(action, values, config) {
    const { country, deviceType, logonId, sessionId } = values;

    const params = {
        session_id: sessionId,
        condition_attrib_1: getDeviceTypeAttr(deviceType),
        application_name: config.head.business?.toUpperCase(),
        line_of_business: country?.toUpperCase(),
        account_email: encodeURI(logonId),
    };

    if (action === 'register') {
        params.account_first_name = encodeURI(values.firstName);
        params.account_last_name = encodeURI(values.lastName);
    }
    return params;
}